import React from 'react';
import styled from 'styled-components';

import apis from '_apis';
import Slider from './Slider';

const Container = styled.div`
  text-align: center;
`;

const Img = styled.img`
  width: 100% !important;
  max-width: 240px !important;
  height: auto !important;
  min-height: 180px !important;
`;

const Wrapper = styled.div`
  max-width: 240px;
  width: 100%;
  min-height: 180px;
  overflow: hidden;
  margin: 0 auto;
`;

const Image = ({ images, alt }) => {
  const imageUrl = (path) => apis.imageUrl(path);

  const renderImage = () => {
    if (!images.length) return null;
    if (images.length > 1) {
      return (
        <Wrapper>
          <Slider images={images} imageUrl={imageUrl} />
        </Wrapper>
      );
    }
    return (<Img src={imageUrl(images[0].path)} alt={alt} />);
  };

  return (
    <Container>
      {
        renderImage()
      }
    </Container>
  );
};

export default Image;
